import Vue from 'vue'
import { createImage} from '~image'
import NuxtImg from '~image/components/nuxt-img.vue'
import NuxtPicture from '~image/components/nuxt-picture.vue'

import * as staticRuntime$97f8 from '/srv/webapps/td-eg-solo-frontend/production/releases/20251113090944/node_modules/@nuxt/image/dist/runtime/providers/static.js'
import * as ipxRuntime$a83a from '/srv/webapps/td-eg-solo-frontend/production/releases/20251113090944/node_modules/@nuxt/image/dist/runtime/providers/ipx.js'

const imageOptions = {
  "screens": {
    "xs": 640,
    "sm": 1024,
    "md": 1280,
    "lg": 1464,
    "xl": 1500,
    "xxl": false,
    "2xl": false
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "production.td-goliath.i22hosting.de"
  ],
  "alias": {
    "/content/content-images": "/public/content/content-images",
    "/product-images/": "https://production.td-goliath.i22hosting.de/public"
  }
}

imageOptions.providers = {
  ['static']: { provider: staticRuntime$97f8, defaults: {} },
  ['ipx']: { provider: ipxRuntime$a83a, defaults: {"baseURL":"//egs-cdn.telekom-dienste.de/_ipx","modifiers":{"format":"webp"}} }
}

Vue.component(NuxtImg.name, NuxtImg)
Vue.component(NuxtPicture.name, NuxtPicture)
Vue.component('NImg', NuxtImg)
Vue.component('NPicture', NuxtPicture)

export default function (nuxtContext, inject) {
  const $img = createImage(imageOptions, nuxtContext)

  if (process.static && process.server) {
    nuxtContext.beforeNuxtRender(({ nuxtState }) => {
      const ssrData = nuxtState.data[0] || {}
      ssrData._img = nuxtState._img || {}
    })
  }

  inject('img', $img)
}
